// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2-4pz","topBottomGutter":"Layout_topBottomGutter__3iYhs"};